import { render, staticRenderFns } from "./QuickLinks.vue?vue&type=template&id=7558a41e"
import script from "./QuickLinks.vue?vue&type=script&lang=ts"
export * from "./QuickLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports